import EditProduct from './EditProduct';

export default EditProduct;
